import React, { useState } from 'react'
import { graphql, useStaticQuery } from 'gatsby'
// Components
import ParkingForm from './forms/parking'
import HotelForm from './forms/hotels'
import HotelAndParkingForm from './forms/hotelAndParking'
// SVGs
import Parking from './svg/parking'
import Hotel from './svg/hotel'
import HotelAndParking from './svg/hotelAndParking'

const SearchForm = (props) => {
  const data = useStaticQuery(graphql`
    {
      prismicNavigation {
        data {
          company_phone
        }
      }
    }
  `)

  const [isProduct, setProduct] = useState(props.product || 'cp')

  return (
    <div className='relative w-full px-4'>
      <div className='mx-auto max-w-screen-xl'>
        <nav className='flex w-full flex-row lg:px-4'>
          <div className='flex'>
            <button
              className={`mr-px flex items-center rounded-t-md border border-transparent p-2 font-medium transition duration-300 ease-in-out focus:outline-none lg:px-3 lg:text-lg ${
                isProduct === 'Parking' ? 'bg-orange-500 text-white shadow-inner' : 'bg-white text-orange-500 hover:bg-orange-100'
              } shadow-lg`}
              onClick={() => setProduct('Parking')}>
              <div className='mr-1 flex h-6 w-6 rounded-full bg-white p-1'>
                <Parking />
              </div>
              <span className='sr-only hidden lg:not-sr-only lg:mr-1 lg:inline-block'>Airport </span>Parking
            </button>
          </div>
          <div className='flex'>
            <button
              className={`mr-px flex items-center rounded-t-md border border-transparent py-3 pr-4 pl-3 font-medium transition duration-300 ease-in-out focus:outline-none lg:text-lg ${
                isProduct === 'Hotels and Parking' ? 'bg-orange-500 text-white shadow-inner' : 'bg-white text-orange-500 hover:bg-orange-100'
              } shadow-lg`}
              onClick={() => setProduct('Hotels and Parking')}>
              <div className='mr-1 flex h-6 w-6 rounded-full bg-white p-1'>
                <HotelAndParking />
              </div>
              <span className='sr-only hidden lg:not-sr-only lg:mr-1 lg:inline-block'>Airport </span> Hotels & Parking
            </button>
          </div>
          <div className='flex'>
            <button
              className={`mr-px flex items-center rounded-t-md border border-transparent py-3 pr-4 pl-3 font-medium transition duration-300 ease-in-out focus:outline-none lg:text-lg ${
                isProduct === 'Hotels' ? 'bg-orange-500 text-white shadow-inner' : 'bg-white text-orange-500 hover:bg-orange-100'
              } shadow-lg`}
              onClick={() => setProduct('Hotels')}>
              <div className='mr-1 flex h-6 w-6 rounded-full bg-white p-1'>
                <Hotel />
              </div>
              <span className='sr-only hidden lg:not-sr-only lg:mr-1 lg:inline-block'>Airport </span> Hotels
            </button>
          </div>
          <div className='ml-auto hidden lg:flex lg:items-center'>
            <p className='text-lg'>
              Call us free to book{' '}
              <a
                className='border-0 text-xl font-medium text-orange-500 hover:underline focus:outline-none focus:ring'
                href={`tel:${data.prismicNavigation.data.company_phone}`}
                target='_blank'
                rel='noopener noreferrer'>
                {data.prismicNavigation.data.company_phone}
              </a>
            </p>
          </div>
        </nav>
      </div>
      {isProduct === 'Parking' && <ParkingForm agentCode={props.agentCode} location={props.location} />}
      {isProduct === 'Hotels' && <HotelForm agentCode={props.agentCode} location={props.location} />}
      {isProduct === 'Hotels and Parking' && <HotelAndParkingForm agentCode={props.agentCode} location={props.location} />}
    </div>
  )
}

export default SearchForm
